import { FlexBox, shadow } from '@Backlot-Cars/archie';
import styled from 'styled-components';

export const BannerContainer = styled(FlexBox).attrs({
	gap: 'md',
	flexDirection: 'column',
	background: 'primary',
	padding: 'md',
	borderRadius: 'xs',
})`
	box-shadow: ${shadow.larger};
`;
